import React, { useState, useEffect } from "react";
import StartButton from "./StartButton";

function StartPage({ onStart }) {
  const [audio] = useState(new Audio("/sound/Welcome.MP3"));
  const [isMuted, setIsMuted] = useState(true);

  const toggleSound = () => {
    if (isMuted) {
      audio.volume = 1;
      audio.play().catch((error) => {
        console.log("Audio playback failed:", error);
      });
    } else {
      audio.pause();
      audio.currentTime = 0;
    }
    setIsMuted(!isMuted);
  };

  useEffect(() => {
    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, [audio]);

  return (
    <div className="flex items-center justify-center w-full">
      <div className="bg-blue-500 rounded-lg shadow-xl w-full max-w-3xl p-8 relative">
        <button
          onClick={toggleSound}
          className="absolute bottom-3 right-3 p-2 bg-yellow-400 hover:bg-yellow-500 rounded-full  shadow-lg transition-all duration-300 hover:scale-105"
        >
          {isMuted ? (
            <span role="img" aria-label="unmute" className="text-xl">
              🔇
            </span>
          ) : (
            <span role="img" aria-label="mute" className="text-xl">
              🔈
            </span>
          )}
        </button>
        <div className="text-center mb-8">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-2">
            Explore Different Cuisines in the World
          </h1>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-yellow-300 mb-4 game-title">
            Cultural Cuisine Game
          </h2>
        </div>

        <div className="flex flex-wrap justify-center gap-8 mb-12">
          {["🍣", "🍕", "🌮", "🍜", "🍛", "🥘"].map((emoji, index) => (
            <div
              key={index}
              className="text-5xl sm:text-6xl md:text-7xl animate-bounce"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {emoji}
            </div>
          ))}
        </div>

        <div className="flex justify-center">
          <StartButton onStart={onStart} />
        </div>
      </div>
    </div>
  );
}

export default StartPage;
